/** Versão do regulamento gravada no aceite por compartilhamento. */
export const REFERRAL_REGULATION_VERSION = "2026-09-24"

export const REFERRAL_CODE_PARAM = "ref"

export const REFERRAL_COOKIE_NAME = "astra_referral_code"

export const REFERRAL_LS_KEY = "referral_code"

export const REFERRAL_LS_CAPTURED_AT_KEY = "referral_code_captured_at"

/** Padrão de mercado: janela entre último clique no link e conclusão do cadastro. */
export const REFERRAL_ATTRIBUTION_WINDOW_DAYS_DEFAULT = 30

export const REFERRAL_CHURNED_BALANCE_EXPIRY_MONTHS_DEFAULT = 12

export function getReferralRewardAmount(): number {
  const raw = process.env.REFERRAL_REWARD_AMOUNT?.trim()
  if (raw) {
    const n = Number(raw)
    if (Number.isFinite(n) && n > 0) return n
  }
  return 100
}

function parseAttributionWindowDays(raw: string | undefined): number | null {
  if (!raw) return null
  const n = Number(raw)
  if (Number.isFinite(n) && n > 0 && n <= 365) return Math.floor(n)
  return null
}

export function getReferralAttributionWindowDays(): number {
  return (
    parseAttributionWindowDays(process.env.REFERRAL_ATTRIBUTION_WINDOW_DAYS?.trim()) ??
    parseAttributionWindowDays(process.env.NEXT_PUBLIC_REFERRAL_ATTRIBUTION_WINDOW_DAYS?.trim()) ??
    REFERRAL_ATTRIBUTION_WINDOW_DAYS_DEFAULT
  )
}

/** Política documentada no regulamento; expiração operacional pode ser implementada em job futuro. */
export function getReferralChurnedBalanceExpiryMonths(): number {
  const raw = process.env.REFERRAL_CHURNED_BALANCE_EXPIRY_MONTHS?.trim()
  if (raw) {
    const n = Number(raw)
    if (Number.isFinite(n) && n > 0 && n <= 60) return Math.floor(n)
  }
  return REFERRAL_CHURNED_BALANCE_EXPIRY_MONTHS_DEFAULT
}
